import AOS from 'aos';
import './modules/hero-carousel';
import './modules/get-in-touch-form';
import './modules/mobile-menu';
import './modules/scroll-to-top';
import './modules/scroll-to-section';

AOS.init({
  once: true,
});
